<template>
  <header class="reservation-head">
    <div @click="back" class="back">
      <img src="../assets/img/back.png" alt="">
    </div>
    <h3 class="head-tit"><slot></slot></h3>
    <div class="more"> </div>
  </header>
</template>

<script>
export default {
  name: 'yyHeader',
  methods: {
    back () {
      window.history.back()
    }
  }

}
</script>

<style lang="less">
.reservation-head {
  max-width: 750px;
  min-width: 320px;
  position: fixed;
  width: 100%;
  top: 0;
  height: 2.2rem /* 110/50 */;
  background-color: @theme-color;
  color: #fff;
  display: flex;
  text-align: center;
  justify-content: space-between;
  line-height: 2.2rem /* 110/50 */;
  font-size: .8rem /* 40/50 */;
  z-index: 99;

  .back {
    width: 1.6rem /* 80/50 */;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: .34rem /* 17/50 */;
      height: .58rem /* 29/50 */;
    }
  }

  .head-tit {
    flex: 1;
    font-size: .8rem /* 40/50 */;
  }
  .more {
    width: 1.6rem /* 80/50 */;
    cursor: pointer;
    padding-right: .4rem /* 20/50 */;
  }
}
</style>
